<template>
    <span v-if="level">
        <v-icon size="small" class="indent dot" v-for="n in level-1" :key="hash + n">mdi-circle-small</v-icon>
        <v-icon size="small" class="indent arrow">mdi-arrow-right-bottom</v-icon>
    </span>
</template>

<script setup lang="ts">
import { nanoid } from 'nanoid';

defineProps<{
  level?: number;
}>();

const hash = nanoid();
</script>

<style lang="scss" scoped>
.indent {
    opacity: 0.5;
    &.dot {
        margin-left: -6px;
    }
    &.arrow {
        margin-bottom: 8px;
        margin-right: 4px;
    }
}
</style>